<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import * as api from '@/services';
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {};
  },
  watch: {
    $route: function() {
      this.$store.dispatch('imDialogService/closeDialog');
    }
  },
  computed: {
    ...mapState('USER', {
      userInfo: state => state.userInfo
    })
  },
  mounted() {},
  async created() {
    if (window.location.href.includes('login') || window.location.href.includes('identify') || window.location.href.includes('crm_')) {
      // 登陆页 认证结果等页面不去调用下面用户信息等接口
      // CRM跳转过来的页面不需要权限验证
    } else {
      // 每次进入应用都去调用userInfo接口
      await this.getUserInfo();
      // 非采购员角色则跳转到提交申请页
      const pcEntrance = await api.login.pcEntrance();
      if (!pcEntrance.drugShopEntrance) {
        this.$message.error('请联系对应销售，开通账户');
        location.href = location.origin + location.pathname + '#/login';
        location.reload();
      }
      if (!(this.userInfo.userInfoVO?.roleList || []).includes('buyers')) {
        this.$router.replace('/identify/status');
      } else {
        // 协议签署状态;
        const res = await api.aggrement.queryUserAgreementSignStatus({
          agreementType: 'B2B_PURCHASER_AGREEMENT'
        });
        // 0 未签署 1 已签署
        if (res === 0) {
          this.$router.replace('/identify/aggrement');
        }
        // 下面后续调用判断是否黑名单/地域限制接口 跳转落地页
      }
    }
  },
  methods: {
    ...mapActions('USER', ['getUserInfo'])
  }
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100vh;
  background: #ffffff;
}
</style>

<style lant="scss">
html,
body {
  height: 100%;
  overflow: hidden;
  /* 影响首页导航样式 */
  /* height: 100%;
  overflow: hidden; */
}
</style>
